import { MosaicTocSectionClass } from "./MosaicTocSectionClass";
import type { IMosaicTocExpanded, ITocActionUpdateSection } from "./interface";

/**
 * Applies an update to an existing ToC section.
 *
 * @param state - The current expanded ToC state.
 * @param action - The action containing the section changes.
 * @returns The updated ToC state after the matching section is refreshed.
 */
export const toc_updateSection = (
  state: IMosaicTocExpanded,
  action: ITocActionUpdateSection,
): IMosaicTocExpanded => {
  const newState: IMosaicTocExpanded = { ...state };
  const index = newState.tocItems.findIndex(
    (item) => item.id === action.update.id && item instanceof MosaicTocSectionClass,
  );

  /* istanbul ignore else -- callers only update sections that already exist in ToC state. */
  if (index > -1) {
    const current = newState.tocItems[index] as MosaicTocSectionClass;
    current.update(action.update);
    if (current.changed) {
      newState.saving = true;
    }
  }

  return newState;
};
